export default __webpack_public_path__ + "static/media/Terms-&-Condition.af397222.jpg";